import type { Lang, LocalizedString } from "./types";
import { DEFAULT_LANG } from "./constants";

export function t(
  value: LocalizedString | Partial<LocalizedString> | undefined,
  lang: Lang = DEFAULT_LANG
): string {
  if (!value) return "";
  return value[lang] ?? value[DEFAULT_LANG] ?? value.en ?? "";
}

export function tHtml(value: LocalizedString | undefined, lang: Lang = DEFAULT_LANG): string {
  return t(value, lang);
}

export function stripHtml(html: string): string {
  return html.replace(/<[^>]*>/g, "");
}
